// 9fbef606107a605d69c0edbcd8029e5d
import styled, { css } from 'styled-components';

export default css`
  margin: 0 13px 0 13px;
  background: ${(props) => props.theme.colors.WHITE};
  ${(props) =>
    props.isOutfitsRedesign
      ? `
    @media ${props.theme.mediaQuery.smallOnly} {
      margin: 0 21px 0 21px;
    }
    @media ${props.theme.mediaQuery.mediumOnly} {
      margin: 0 24px 0 24px;
    }
    @media ${props.theme.mediaQuery.large} {
      margin: 24px;
    }
    `
      : ''}
  .product-detail-skeleton-wrapper {
    display: flex;
    flex-direction: column;
    ${(props) =>
      props.isOutfitsRedesign
        ? `
      @media ${props.theme.mediaQuery.mediumOnly} {
        flex-direction: row;
        gap: 32px;
      }
      @media ${props.theme.mediaQuery.large} {
        gap: 37px;
        flex-direction: row;
      }
      `
        : ''}
  }
  .product-main-image {
    height: 436px;
    width: 100%;
    margin-bottom: 40px;
    margin-right: 0;
  }
  .product-overview-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-left: 0;
    padding-top: 16px;
    border-bottom: 1px solid #d8d8d8;
  }
  .product-title {
    width: 100%;
    height: 50px;
    margin-bottom: 28px;
  }
  .product-price {
    width: 70%;
    height: 50px;
    margin-bottom: 30px;
  }
  .product-color {
    width: 100%;
    height: 70px;
    margin-bottom: 50px;
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      width: 50%;
    }
  }
  .product-size {
    width: 100%;
    height: 70px;
    margin-bottom: 70px;
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      width: 70%;
    }
  }
  .product-add-to-bag {
    width: 100%;
    height: 60px;
    margin-bottom: 24px;
  }
  .product-image {
    margin-right: 20px;
    margin-bottom: 20px;
    height: 50px;
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      height: 218px;
      width: 171px;
    }
  }
  .outfit-image {
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
  }
  .product-gird-skeleton {
    display: grid;
    grid-gap: 16px; /* Adjust the gap between boxes as needed */
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    @media ${(props) => props.theme.mediaQuery.medium} {
      grid-template-columns: repeat(4, 1fr);
    }
    @media (min-width: 1024px) {
      /* Large screen: Display 2 columns */
      grid-template-columns: repeat(2, 1fr);
    }
  }

  .product-overview-detail-wrapper {
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      display: flex;
      flex-direction: row;
    }
  }
  .product-title-price-wrapper {
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      width: 46%;
    }
  }
  @media ${(props) => props.theme.mediaQuery.medium} {
    .product-detail-skeleton-wrapper {
      display: flex;
      flex-direction: row;
    }
    .product-main-image {
      height: 703px;
      flex: 1;
      margin-right: 5%;
    }
    .product-overview-wrapper {
      flex: 1;
      display: flex;
      flex-direction: column;
      margin-right: 2%;
    }
    .product-overview-detail-wrapper {
      width: 100%;
      display: flex;
      flex-direction: row;
    }
    .product-image {
      flex: 1;
      display: flex;
      height: 261px;
      margin-right: 20px;
    }
    .product-title-price-wrapper {
      flex: 2;
      display: flex;
      flex-direction: column;
    }
  }
  .product-overview-wrapper-main {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-right: 2%;
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    .product-detail-skeleton-wrapper {
      display: flex;
      flex-direction: row;
    }
    .product-main-image {
      width: 660px;
      height: 703px;
      flex: 1;
      margin-right: 5%;
    }
    .product-overview-wrapper {
      flex: 1;
      display: flex;
      flex-direction: column;
      margin-right: 2%;
    }
    .product-overview-detail-wrapper {
      width: 100%;
      display: flex;
      flex-direction: row;
    }
    .product-image {
      flex: 1;
      display: flex;
      height: 261px;
      margin-right: 20px;
    }
    .product-title-price-wrapper {
      flex: 2;
      display: flex;
      flex-direction: column;
    }
  }

  ${(props) => (props.inheritedStyles ? props.inheritedStyles : '')};
`;
export const StyledOutfitCarouselSkeleton = styled.div`
  box-sizing: border-box;
  width: 100%;
  position: relative;
  display: block;

  @media ${(props) => props.theme.mediaQuery.medium} {
    width: 390px;
    min-height: 390px;
  }

  @media ${(props) => props.theme.mediaQuery.large} {
    min-width: 660px;
    max-width: 740px;
    min-height: 660px;
  }
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    padding: 0px 30px !important;
  }
  .promo-area-0 {
    border: 1px solid #9b9b9b;
    border-radius: 6px;
  }
`;

export const StyledPaginatedGridSkeleton = styled.div`
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    height: 385px;
  }

  @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    height: 386px;
  }

  @media ${(props) => props.theme.mediaQuery.large} {
    height: 509px;
  }
  .grid-image-skeleton {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      height: 210px;
    }

    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      height: 210px;
    }

    @media ${(props) => props.theme.mediaQuery.large} {
      height: 300px;
    }
    margin-bottom: 12px;
  }
  .grid-price-skeleton {
    display: flex;
    justify-content: space-between;
    @media ${(props) => props.theme.mediaQuery.large} {
      margin-top: 24px;
      height: 48px;
    }
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      margin-top: 20px;
      height: 35px;
    }
  }
  .grid-promo-skeleton {
    margin-top: 10px;
    height: 25px;
  }
  .grid-title-skeleton {
    margin-top: 4px;
    height: 35px;
  }
`;
